import type {ISubdominio, ISubdominioCompleto} from "services-comun/modules/net/config/dominio";
import {immute} from "services-comun/modules/utiles/object";

import {DominioTiempo, IDominioTiempoConfig} from "../";

class DominioTiempoES extends DominioTiempo {
    /* STATIC */
    public static readonly FORO: ISubdominioCompleto = immute({
        nombre: "foro",
        scheme: "https",
    });
    public static readonly USUARIOS: ISubdominioCompleto = immute({
        nombre: "usuarios",
        scheme: "https",
    });

    /* INSTANCE */
    protected readonly SUBDOMINIO_FORO = DominioTiempoES.FORO;
    protected readonly SUBDOMINIO_USUARIOS = DominioTiempoES.USUARIOS;

    public readonly FORO = this.SUBDOMINIO_FORO.nombre;
    public readonly USUARIOS = this.SUBDOMINIO_USUARIOS.nombre;

    public constructor(config: IDominioTiempoConfig, subdominios: Required<ISubdominio>[]=[]) {
        super(config, [DominioTiempoES.FORO, DominioTiempoES.USUARIOS, ...subdominios]);
    }
}

const tiempo_es = immute(new DominioTiempoES({ dominio: "tiempo.com", id: "es", pais: 18, idiomas: ["es-ES"], }));

export default tiempo_es;
